import React, { useState, useEffect } from 'react';
import { ProductModel } from 'models/ProductModel';
import { useCart } from 'services/CartService';
import { SquareMinus, SquarePlus, Trash2 } from 'lucide-react';
import { Draggable } from '../Drop/Draggable';

const CartProductList: React.FC<{ checkout?: boolean }> = (props) => {
  const { addToCart, removeFromCart, getCart } = useCart();
  const [productsCart, setProductsCart] = useState<ProductModel[]>([]);

  useEffect(() => {
    setProductsCart(getCart());
  }, [getCart]);

  const handleAddToCart = (productId: string) => {
    addToCart(productId, 1, true);
    setProductsCart(getCart());
  };

  const handleRemoveFromCart = (productId: string, quantity: number) => {
    removeFromCart(productId, quantity);
    setProductsCart(getCart());
  };

  // const handleSelectProduct = (product: ProductModel) => {
  //   updateCartItemSelected(product.productId, !product.selected);
  //   setProductsCart(getCart());
  // };

  const checkForSelectedProduct = () => {
    if (productsCart.length < 1) {
      return <p className='text-center text-primary'>Votre panier est vide</p>
    } else if (productsCart.every(product => !product.selected)) {
      return <p className='text-center text-accent'>Veuillez sélectionner un produit</p>
    } else {
      return null;
    }
  }

  // style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}

  return (
    <div>
      {checkForSelectedProduct()}
      <ul>
        {productsCart.map((product, index) => (
          <>
            <Draggable key={index} id={-(index+1)} product={product} fromCart>
              <li className={`flex items start bg-[#F9F4E7] rounded-md cursor-move px-1 pb-1`}>
                <div className={`w-12 bg-gray-200 rounded overflow-hidden mt-1 ${!product.selected || !product.isAvailable ? 'opacity-50 cursor-not-allowed' : ''}`}>
                  <img src={product.image} alt={product.productName} className="w-full h-full object-cover" />
                </div>
                <div className='flex-1 px-1'>
                  {/* {!props.checkout && <input
                    type="checkbox"
                    checked={product.selected}
                    onChange={() => handleSelectProduct(product)}
                    className="w-5 h-5 mr-2"
                    style={{ accentColor: '#006400' }}
                    disabled={!product.isAvailable}
                  />} */}
                  <p className={`font-bold text-xs font ${!product.selected || !product.isAvailable ? 'opacity-50 cursor-not-allowed' : ''}`}>
                    {(product.productName.charAt(0).toUpperCase() + product.productName.slice(1).toLowerCase()).slice(0,50)}{product.productName.length > 50 && '...'}
                  </p>
                  <p className='text-xs text-gray-400'>Colis : {product.minimum} {product.unitFormat}</p>

                  <div className='flex justify-between'>
                    <div className={`flex items-center mt-1 gap-1 ${!product.selected || !product.isAvailable ? 'opacity-50 cursor-not-allowed' : ''}`}>
                      {!props.checkout && <button
                        className="grid place-items-center"
                        onPointerDown={(event) => event.stopPropagation()}
                        onClick={() => handleRemoveFromCart(product.productId, 1)}
                        disabled={!product.isAvailable}
                      >
                        <SquareMinus strokeWidth={1} />
                      </button>}
                      {props.checkout && <span>quantité : </span>}
                      <span className="text-xs font-bold">{product.quantity}</span>
                      {!props.checkout && <button
                        className="grid place-items-center"
                        onPointerDown={(event) => event.stopPropagation()}
                        onClick={() => handleAddToCart(product.productId)}
                        disabled={!product.isAvailable}
                      >
                        <SquarePlus strokeWidth={1} />
                      </button>}
                    </div>
                    {product.isAvailable ?
                      <div className='flex flex-col items-end'>
                        <p className="font-bold text-sm">{product.quantity && product.price && (product.price * product.quantity * product.minimum).toLocaleString("fr-FR", { minimumFractionDigits: 2 })}€</p>
                      </div>
                      :
                      <div className='flex flex-col items-end'>
                        <p className="font-bold text-md text-red-500 opacity-100">Indisponible</p>
                        <div className="right-0 top-0 p-1 opacity-100">
                          <button
                            onClick={() => handleRemoveFromCart(product.productId, product.quantity)}
                            className="p-1 mt-5 rounded-full hover:bg-rose-200"
                          >
                            <Trash2 color="red" />
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </li>
            </Draggable>
            <hr className="my-2" />
          </>
        ))}
      </ul>
    </div>
  );
};

export default CartProductList;
